/**
 * A random v4 UUID. Shared with the mobile app, where Hermes has no global
 * `crypto.randomUUID`, so fall back to Math.random there.
 */
export function randomUuid(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, char => {
    const nibble = Math.floor(Math.random() * 16);
    return (char === 'x' ? nibble : (nibble & 0x3) | 0x8).toString(16);
  });
}
